import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import EventTypeSelector from './field/event-type-selector'
import Field from './field'
import TextInput from './field/text-input'
import TextArea from './field/text-area'
import ImageInput from './field/image-input'
import FieldError from './field/field-error'
import VenueSearch from './field/venue-search'
import Wysiwyg from '../wysiwyg'
import Checkbox from './field/checkbox'

import styles from './setupform-form.css'
import { CROPPER_MIN_IMAGE_WIDTH, CROPPER_MIN_IMAGE_HEIGHT } from '../../constants/cropper-tool-constants'

const SetupformVoucherForm = ({ fields }) => (
  <form styleName="form">

    <Field
      description={
        'Give your product a title that stands out. It’s often effective to run with something ' +
        'compelling and actionable, e.g. Award-Winning Jazz + Two-Course Meal.'
      }
      name="Product Name"
    >
      <TextInput data={fields.name} placeholder="An Awesome Voucher" />
      <FieldError data={fields.name} />
    </Field>

    <Field
      description={
        'Describe the product to your customers. ' +
        'Provide as much information as possible, while trying to keep it witty and concise.'
      }
      name="Description"
    >
      <Wysiwyg
        onChange={fields.description.onChange}
        value={fields.description.value}
        placeholder="An Awesome Product is your unique opportunity..."
      />
      <FieldError data={fields.description} />
    </Field>

    <Field
      description={
        'A short offer description (maximum 24 characters) ' +
        'which will appear in the Offer section on the product page.'
      }
      name="Offer Description"
    >
      <TextInput data={fields.rawOfferText} placeholder="This offer is great!" />
      <FieldError data={fields.rawOfferText} />
    </Field>

    <Field
      description="A short pithy description of your product which will be displayed alongside it when shown on YPlan"
      name="Tagline"
    >
      <TextInput data={fields.tagline} placeholder="This product is great!" />
      <FieldError data={fields.tagline} />
    </Field>

    <Field name="What category is your product?">
      <EventTypeSelector data={fields.eventTypeId} />
      <FieldError data={fields.eventTypeId} />
    </Field>

    <Field
      description={
        `Select an image that will be displayed on the website. It must be at ` +
        `least ${CROPPER_MIN_IMAGE_WIDTH}x${CROPPER_MIN_IMAGE_HEIGHT}.`
      }
      name="Choose an image for your product"
    >
      <ImageInput data={fields.image} placeholder="Please select an image from your computer" />
      <FieldError data={fields.image} />
    </Field>

    <Field name="Venue">
      <VenueSearch
        placeholder="Search for a venue"
        venueAddressData={fields.venueAddress}
        venueIdData={fields.venueId}
        venueNameData={fields.venueName}
        allowNoVenue
      />
      <FieldError data={fields.venueId} />
    </Field>

    {/* Hidden for the moment, whilst the database is modified
        to support saving these days at the setup form level

    <Field
      description={
        'When will the product be available for sale'
      }
      name="Available from"
    >
      <InputDateTimeLocal data={fields.availableFrom} />
      <FieldError data={fields.availableFrom} />
    </Field>

    <Field
      description={
        'When will the product stop being available for sale'
      }
      name="Available to"
    >
      <InputDateTimeLocal data={fields.availableTo} />
      <FieldError data={fields.availableTo} />
    </Field>
    */}

    <Field
      description="Add instructions that describe how to redeem the product"
      name="Redemption instructions"
    >
      <Wysiwyg
        onChange={fields.redeemInstructions.onChange}
        value={fields.redeemInstructions.value}
        placeholder="e.g. Children under 16 must be accompanied by a responsible adult."
      />
      <FieldError data={fields.redeemInstructions} />
    </Field>

    <Field
      description="Add relevant terms and conditions that we need to let your customers know about."
      name="Terms & Conditions"
    >
      <Wysiwyg
        onChange={fields.terms.onChange}
        value={fields.terms.value}
        placeholder="e.g. Children under 16 must be accompanied by a responsible adult."
      />
      <FieldError data={fields.terms} />
    </Field>

    <Field
      description={
        'Is product shippable?'
      }
      name="Shippable"
    >
      <Checkbox
        data={fields.shippable}
      />
      <FieldError data={fields.shippable} />
    </Field>

  </form>
)

SetupformVoucherForm.propTypes = {
  fields: PropTypes.object,
}

export default CSSModules(SetupformVoucherForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/setupform-voucher-form.js
 **/